import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SubheaderModule } from '../subheader/subheader.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ExpireMessageComponent } from './expire-message/expire-message.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';



@NgModule({
  declarations: [DashboardComponent, ExpireMessageComponent],
  imports: [
    CommonModule,
    FormsModule,
    SubheaderModule,
    SharedModule,
    BrowserAnimationsModule
  ],
  exports : [DashboardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule { }
